import * as ReactDOM from 'react-dom/client';
import PlusConfigProvider from '@fle-ui/plus-config-provider';
import Router from '@/router';
import theme, { cacheThemeToken, cacheSameSiteToken } from '@/theme';

import '@/style/reset.less';
import '@/style/index.less';

const container = document.getElementById('root');

const root = ReactDOM.createRoot(container!);

// 缓存主题 token
cacheThemeToken();

// 缓存 token
cacheSameSiteToken();

root.render(
  <PlusConfigProvider theme={theme}>
    <Router />
  </PlusConfigProvider>,
);
